import Yup from 'utils/validation';

const baseSchema = {
  agent: Yup.object({
    name: Yup.string()
      .min(2, 'Agent name must be at least 2 characters')
      .max(100, 'Agent name must not exceed 100 characters')
      .required('Agent name is required'),
    id: Yup.string()
  }).required('Agent is required')
};

// Schema for Email channel - includes required subject line
export const sourcingSharedCustomizeMessageEmailSchema = Yup.object({
  ...baseSchema,
  customTemplatedSubjectLine: Yup.string()
    .min(1, 'Subject line is required')
    .required('Subject line is required'),
  customTemplatedMessage: Yup.string()
    .min(2, 'Message must be at least 2 characters')
    .required('Message is required')
});

// Helper function to strip template variables from a string for character counting
const stripTemplateVariables = (value: string): string => {
  return value.replaceAll(/{{(.*?)}}/g, '');
};

// Schema for SMS channel - no subject line field
export const sourcingSharedCustomizeMessageSmsSchema = Yup.object({
  ...baseSchema,
  customTemplatedMessage: Yup.string()
    .min(2, 'Message must be at least 2 characters')
    .test(
      'max-characters-without-variables',
      'Reduce your message to 400 characters or less.',
      (value) => {
        if (!value) return true;
        return stripTemplateVariables(value).length <= 400;
      }
    )
    .required('Message is required')
});

// Type for Email form data
export type SourcingSharedCustomizeMessageEmailFormData = Yup.InferType<
  typeof sourcingSharedCustomizeMessageEmailSchema
>;

// Type for SMS form data
export type SourcingSharedCustomizeMessageSmsFormData = Yup.InferType<
  typeof sourcingSharedCustomizeMessageSmsSchema
>;
